module.exports = __webpack_public_path__ + "img/ic_history_march.4f8e913d.png";